import React, { useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { industryOptions } from '../CommonFile/DropdownValues';

const Industry = ({ selectedIndustries, setSelectedIndustries, sicCode, setSicCode, subIndustry, setSubIndustry, search, setSearch, showModal, setShowModal, viewResult }) => {

    const [sicInput, setSicInput] = useState("")
    const handleRemoveIndustry = (itemToRemove) => {
        setSelectedIndustries(selectedIndustries.filter(item => item !== itemToRemove));

        if (selectedIndustries.filter(item => item !== itemToRemove).length === 0) {
            setSearch("");
        }
    };

    const handleAddSic = () => {
        if (sicInput && !sicCode.includes(sicInput)) {
            setSicCode([...sicCode, sicInput]);
            setSicInput('');
        }
    };

    const handleRemoveJobTitle = (item) => {
        setSicCode((prev) => prev.filter((val) => val !== item));
    };


    return (
        <div className="search-contact-filter-container-second-third-div mt-4">
            <div className="search-contact-filter-container-second-third-inner-div">
                <h6>🛠️ Industries</h6>
            </div>
            <Form className="search-contact-form-container">
                <Row className="mb-3">
                    <Col md={viewResult ? 12 : 6}>
                        <Form.Group controlId="industry">
                            <Form.Label className="pb-2 pt-2">Industry</Form.Label>
                            <div className="type-head-selected-container mb-2">
                                {selectedIndustries.map((item, index) => (
                                    <div key={index} className="type-head-selected-options">
                                        <span className="cross-mark" onClick={() => handleRemoveIndustry(item)}>
                                            &times;
                                        </span>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Typeahead
                                    flip={true}
                                    id="industry-typeahead"
                                    className="w-100"
                                    options={industryOptions.map(opt => opt.label).filter(opt => !selectedIndustries.includes(opt))}
                                    // options={preSubInd.filter(opt => !selectedIndustries.includes(opt.value))}
                                    placeholder="Enter industry name"
                                    onInputChange={(val) => {
                                        setSearch(val); // Update search state
                                    }}
                                    onChange={(val) => {
                                        if (val.length > 0 && !selectedIndustries.includes(val[0])) {
                                            setSelectedIndustries([...selectedIndustries, val[0]]); // Store it as an object

                                            setSearch('');
                                        }
                                    }}
                                    // selectedIndustries={[]}
                                    selected={[]}
                                />

                                {/* <Button className="btn btn-primary search-view-result-btn" onClick={openModal}>
                                    Browse
                                </Button> */}
                            </div>
                        </Form.Group>
                    </Col>

                    {/* SIC Code */}
                    <Col md={viewResult ? 12 : 6}>
                        <Form.Group controlId="jobTitle">
                            <Form.Label className="pb-2 pt-2">SIC Code</Form.Label>
                            <div className="type-head-selected-container mb-2">
                                {sicCode.map((title, index) => (
                                    <div key={index} className="type-head-selected-options">
                                        <span className="cross-mark" onClick={() => handleRemoveJobTitle(title)}>
                                            &times;
                                        </span>
                                        <span>{title}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Form.Control
                                    type="text"
                                    placeholder="Enter SIC code"
                                    value={sicInput}
                                    onChange={(e) => setSicInput(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            handleAddSic();
                                        }
                                    }}
                                />
                                <Button
                                    className="btn btn-primary search-view-result-btn"
                                    onClick={handleAddSic}
                                >
                                    {viewResult ? <i className="fa fa-plus"></i> : "Add"}
                                </Button>
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default Industry;
